import { ky } from './client'

export const getSamlConfig = async () => {
  try {
    const response = await ky.get('saml/config')
    console.log(response)
    return await response.json()
  } catch (error) {
    console.error(error)
    return null
  }
}

export const updateSamlConfig = async (config) => {
  try {
    const response = await ky.put('saml/config', { json: config })
    return await response.json()
  } catch (error) {
    console.error(error)
    return null
  }
}
